import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding-bottom":"50px"} }

import zhCN from "ant-design-vue/es/locale/zh_CN";
import { getGlobalSetting } from "@/globalSetting";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const toPlat = () => {
  window.open(getGlobalSetting().manageUrl, "_blank")
}
const toBeian = () => {
  window.open("http://beian.miit.gov.cn/", "_blank");
}
const toCompany = () => {
  window.open('https://www.jsniti.com/', '_blank')
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_config_provider, { locale: _unref(zhCN) }, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    }, 8, ["locale"]),
    _createElementVNode("div", { class: "layout-footer" }, [
      _createElementVNode("span", { onClick: toPlat }, "监管服务平台"),
      _createElementVNode("span", {
        style: {"margin-left":"30px"},
        onClick: toBeian
      }, "网络备案号：苏ICP备2021007623号-2"),
      _createElementVNode("span", {
        style: {"margin-left":"30px"},
        onClick: toCompany
      }, "技术支持：南京智慧交通信息股份有限公司")
    ])
  ]))
}
}

})